import { render, staticRenderFns } from "./HotelSalesReport.vue?vue&type=template&id=5952472b&scoped=true"
import script from "./HotelSalesReport.vue?vue&type=script&lang=js"
export * from "./HotelSalesReport.vue?vue&type=script&lang=js"
import style0 from "./HotelSalesReport.vue?vue&type=style&index=0&id=5952472b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5952472b",
  null
  
)

export default component.exports